/**
 * Utility functions for transforming message formats between API and UI
 */

import { parseToolEvents } from './parsers/toolEventParser';

/**
 * Transform API message format (MessageDetailsDto) to UI message format
 * @param {Array} apiMessages - Array of MessageDetailsDto objects from API
 * @returns {Array} Array of UI message objects compatible with ChatMessages component
 */
export function transformApiMessagesToUI(apiMessages) {
  if (!apiMessages || !Array.isArray(apiMessages)) {
    return [];
  }

  return apiMessages.map((apiMessage) => {
    // Clean tool events from the message content
    const { cleanText, events } = parseToolEvents(apiMessage.content || '');

    return {
      // Use the API message ID directly
      id: apiMessage.id,

      // Use cleaned text without tool event markers
      text: cleanText,

      // Map participant to sender ('user' or 'bot')
      sender: apiMessage.participant === 'user' ? 'user' : 'bot',

      // Convert ISO date string to JavaScript Date object
      timestamp: new Date(apiMessage.createdAt),

      // Set empty context for loaded messages
      context: {},

      // Transform attachments to UI format
      attachments: (apiMessage.attachments || []).map((attachment) => ({
        url: attachment.url,
        contentType: attachment.contentType,
        fileName: attachment.fileName,
        sizeInBytes: attachment.sizeInBytes,
        createdAt: attachment.createdAt,
      })),

      // Optionally store extracted tool events for future use
      // toolEvents: events,

      // Don't include image/imageName as they're for new uploads only
      // Don't include isStreaming, isError, etc. as these are runtime states
    };
  });
}
